import { Box, Flex, Grid, Text } from "@chakra-ui/react"
import { Wallet, HandCoins, ReceiptText, PiggyBank } from "lucide-react"


const StatCard = ({ label, value, icon, iconBg, iconColor }) => {
  return (
    <Flex
      align="center"
      gap={5}
      p={6}
      bg="white"
      borderRadius="3xl"
      border="1px solid"
      borderColor="gray.200"
      boxShadow="sm"
      _hover={{ boxShadow: "md" }}
      transition="all 0.2s"
    >
      <Flex
        w="64px"
        h="64px"
        align="center"
        justify="center"
        borderRadius="full"
        bg={iconBg}
        color={iconColor}
      >
        {icon}
      </Flex>

      <Box>
        <Text
          fontSize="16px"
          fontWeight="400"
          color="#718EBF"
          fontFamily="inter, sans-serif"
        >
          {label}
        </Text>

        <Text
          fontSize="24px"
          fontWeight="600"
          color="#232323"
          fontFamily="Inter, sans-serif"
        >
          {value}
        </Text>
      </Box>
    </Flex>
  )
}

const StatCards = () => {
  const stats= [
    {
      label: "Current Balance",
      value: "₹ 45,000",
      icon: <Wallet size={28} />,
      iconBg: "orange.50",
      iconColor: "orange.500",
    },
    {
      label: "Total Deposited",
      value: "₹ 1,20,000",
      icon: <HandCoins size={28} />,
      iconBg: "blue.50",
      iconColor: "blue.600",
    },
    {
      label: "Total Withdrawn",
      value: "₹ 75,000",
      icon: <ReceiptText size={28} />,
      iconBg: "red.50",
      iconColor: "red.400",
    },
    {
      label: "Pending Payouts",
      value: "₹ 5,000",
      icon: <PiggyBank size={28} />,
      iconBg: "green.50",
      iconColor: "green.400",
    },
  ]

  return (
    <Grid
      templateColumns={{
        base: "1fr",
        md: "repeat(2, 1fr)",
        lg: "repeat(4, 1fr)",
      }}
      gap={6}
      mb={8}
    >
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </Grid>
  )
}

export default StatCards
